// =========================================================
// ACHTUNG - Source ist generiert!!! (2023-07-03T08:35:59.280Z)
// von csv-to-ts-fragen-block-gen.ts
// ---------------------------------------------------------

export interface IZusatzFlagsFuerSonderBehandlung {
  // KPOR-2644
  only_paragraph_3_1_15_tarifeExistsInAntrag?: boolean;
}

export interface IRollenFeatures {
  rolle: string;
  fragenDefs: IAntragFragen;
}

export interface ITarifFeature {
  tarifNr: string;
  kurzBez: string;
  bez: string;
  risikoKlasse: number;
  fragenDefs: IAntragFragen;
  zusatzFlagsFuerSonderBehandlung?: IZusatzFlagsFuerSonderBehandlung;
}

export class IAntragFragen {
  gesundheitsfragenG?: Set<string> = new Set<string>();
  gesundheitsfragenCTFS?: boolean = false;
  gesundheitsfragen?: boolean = false;
  geldwaesche?: boolean = false;
  sensibleDaten?: boolean = false;
  bezugsrechtErleben?: boolean = false;
  bezugsrechtAbleben?: boolean = false;
  bezugsrechtKrankheit?: boolean = false;
  paragraph_3_1_15?: boolean = false;
  treuhaenderFrage?: boolean = false;
  arbeitsStatusFrage?: boolean = false;
  identifikationsnachweis?: boolean = false;
  crsRelevant?: boolean = false;
  fatcaGMSG?: boolean = false;
  veranlagungBeratung?: boolean = false;
  schriftformDatennutzung?: boolean = false;
  bestattung?: boolean = false;
  familienstand?: boolean = false;
  geburtsland?: boolean = false;
  berufsinfo?: boolean = false;
  sozialVersDaten?: boolean = false;
  adresse?: boolean = false;
  nationalitaet?: boolean = false;
  erhaltbasisInfoBlatt?: boolean = false;
  uvPersonenFragen?: boolean = false;
}
